import { AddressValidatedJsonldAddressValidatedRead } from '@/api/generated';
import Button, { BUTTON_VARIANTS } from '@/atoms/Button';
import TextInput from '@/atoms/forms/Input';
import Select from '@/atoms/forms/Select';
import Form from '@/molecules/Form';
import * as Dialog from '@radix-ui/react-dialog';
import useCountriesOptions from 'hooks/options/useCountriesOptions';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useAddressForm from './hook';

const AddressForm = ({
  validateAddress,
}: {
  validateAddress: ({
    values,
    countryCode,
    zipCode,
  }: {
    values: string;
    countryCode: string;
    zipCode: string;
  }) => Promise<AddressValidatedJsonldAddressValidatedRead>;
}) => {
  const { formMethods, onSubmit, formState } = useAddressForm({ validateAddress });
  const { t } = useTranslation();
  const { countriesOptions } = useCountriesOptions();

  return (
    <>
      {!!Object.keys(formState.errors).length && (
        <p className="text-system-error-400 sm-medium mb-4">{t('address.modal.createAddress.header.errorLabel')}</p>
      )}
      <FormProvider {...formMethods}>
        <Form onSubmit={onSubmit}>
          <Select
            disabled={!countriesOptions}
            label="country"
            name="countryCode"
            options={countriesOptions || {}}
            placeholder="country"
            required
          />
          <div className="flex md:flex-row flex-col gap-3">
            <TextInput label="city" name="city" placeholder="city" type="text" required />
            <TextInput label="zipcode" name="zipCode" placeholder="zipcode" type="text" required />
          </div>
          <div className="flex md:flex-row flex-col gap-3">
            <TextInput label="address" name="address" placeholder="address" type="text" required />
            <TextInput label="state" name="state" placeholder="state" type="text" />
          </div>

          <div className="flex flex-col md:flex-row pb-6 gap-3 bg-mercury-50 mt-8 rounded-b-lg">
            <Dialog.DialogClose asChild>
              <Button className="grow" type="button" variant={BUTTON_VARIANTS.SECONDARY}>
                {t('cancel')}
              </Button>
            </Dialog.DialogClose>
            <Dialog.DialogClose asChild>
              <Button className="grow" disabled={formState.isSubmitting} onClick={onSubmit} type="submit">
                {t('validate')}
              </Button>
            </Dialog.DialogClose>
          </div>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddressForm;
